"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_junkmail_configuration_1 = require("owa-junkmail-configuration");
var owa_mail_option_common_1 = require("owa-mail-option-common");
exports.default = legacy_1.select({
    mailboxJunkEmailConfiguration: function () { return owa_junkmail_configuration_1.getMailboxJunkEmailConfiguration(); },
    optionState: function () { return store_1.default; },
})(legacy_1.action('saveBlockedSendersOption')(function saveBlockedSendersOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, mailboxJunkEmailConfiguration, optionState, blockedSenders, blockedDomains, blockedSenderAndDomains;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = state, mailboxJunkEmailConfiguration = _a.mailboxJunkEmailConfiguration, optionState = _a.optionState;
                    blockedSenders = owa_options_core_1.getFallbackValueIfNull(optionState.blockedSenders, mailboxJunkEmailConfiguration.BlockedSendersAndDomains.filter(function (item) {
                        return owa_mail_option_common_1.isEmailAddress(item);
                    }));
                    blockedDomains = mailboxJunkEmailConfiguration.BlockedSendersAndDomains.filter(function (item) { return !owa_mail_option_common_1.isEmailAddress(item); });
                    blockedSenderAndDomains = blockedSenders.slice(0).concat(blockedDomains);
                    mailboxJunkEmailConfiguration.BlockedSendersAndDomains = blockedSenderAndDomains;
                    return [4 /*yield*/, owa_junkmail_configuration_1.saveMailboxJunkEmailConfiguration(mailboxJunkEmailConfiguration)];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveBlockedSendersOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-blocked-senders-option/lib/actions/saveBlockedSendersOption.js
// module id = 5035
// module chunks = 2